<div class="qwyk-table-root">
    <div *ngIf="captionTemplate" class="qwyk-table-caption">
        <ng-container *ngTemplateOutlet="captionTemplate"></ng-container>
    </div>

    <div class="qwyk-scroll-wrap"
         [class.shadow-left]="_shadowLeft"
         [class.shadow-right]="_shadowRight"
         [class.shadow-top]="_shadowTop"
         [class.shadow-bottom]="_shadowBottom">
        <div #scrollEl
             class="qwyk-table-scroll"
             [style.max-height]="scrollHeight"
             [class.qwyk-table-scrollable]="!!scrollHeight"
             (scroll)="_onScroll()">
            <table class="qwyk-table"
                   [class.qwyk-table-fixed]="!!_tableWidth"
                   [style.width]="_tableWidth ? _tableWidth + 'px' : null">
                <thead *ngIf="headerTemplate">
                    <ng-container
                        *ngTemplateOutlet="headerTemplate; context: { $implicit: _displayedColumns }"
                    ></ng-container>
                </thead>

                <tbody>
                    <ng-container *ngIf="loading && loadingBodyTemplate; else dataOrEmpty">
                        <ng-container *ngTemplateOutlet="loadingBodyTemplate"></ng-container>
                    </ng-container>

                    <ng-template #dataOrEmpty>
                        <ng-container *ngIf="_displayedValue?.length > 0; else emptyBlock">
                            <ng-container *ngFor="let row of _displayedValue">
                                <ng-container
                                    *ngTemplateOutlet="bodyTemplate; context: { $implicit: row, columns: _displayedColumns }"
                                ></ng-container>
                            </ng-container>
                        </ng-container>

                        <ng-template #emptyBlock>
                            <ng-container
                                *ngIf="emptyMessageTemplate"
                            >
                                <ng-container *ngTemplateOutlet="emptyMessageTemplate"></ng-container>
                            </ng-container>
                        </ng-template>
                    </ng-template>
                </tbody>
            </table>
        </div>
        <div class="qwyk-scroll-shadow qwyk-scroll-shadow-left"></div>
        <div class="qwyk-scroll-shadow qwyk-scroll-shadow-right"></div>
        <div class="qwyk-scroll-shadow qwyk-scroll-shadow-top" [style.top.px]="_theadHeight"></div>
        <div class="qwyk-scroll-shadow qwyk-scroll-shadow-bottom"></div>
    </div>

    <div *ngIf="summaryTemplate" class="qwyk-table-summary">
        <ng-container *ngTemplateOutlet="summaryTemplate"></ng-container>
    </div>
</div>
